import React, {useEffect, useRef, useState} from 'react';
import Close from "../../../resources/icon/close-white.png";
import useCodeData from "../../../hooks/useCodeData";
import {getFlatCode, getIdsFromMulipleMeToParent, isAdmin} from "../../commonmethod/CommonMethod";
import JellyCheckBox from "../../search/JellyCheckBox";
import CommonPagination from "../../table/movable/CommonPagination";
import {DrawerTriger, Label} from "../drawer/Style";
import {ITER_List} from "./ITER_List";
import {getUser} from "../../../api/user/UserAccountService";
import {isEqual} from "lodash";
import {useSelector} from "react-redux";
import {useHandleApiSelect} from "../../../api/apiselector/ApiSelector";
import {useTranslation} from "react-i18next";
import {handleActiveError, handleActiveToast} from "../../sonner/ToastBasic";
import {Link} from "react-router-dom";

/**
 * data         |  필수  |  obj  | 선택된 값
 * onChange     |  필수  |   f   | 선택된 값을 변경해주는 세터    |
 * target       |  필수  |   v   | 선택된 값으로 변경해줄 대상 지정
 * entity       |  필수  |  obj  | 드로어에 나와야 하는 코드값  | {name, (옵셔널)parentKey }
 *
 * index        | 옵셔널 |   v   | ITER_ : iterator 요소의 몇 번째 인지
 * constraint   | 옵셔널 |  obj  | { required, lessThan, largerThan }
 * onUpdate     | 옵셔널 |   f   | api 요청
 * auth         | 옵셔널 | bool  | 수정가능 여부, 없으면 수정 불가.
 * placeHolder  | 옵셔널 |   v   | 버튼의 기본 문구. 없으면 '선택'
 * title        | 옵셔널 |   v   | 드로어의 탸이틀
 * recursive    | 옵셔널 | bool  | 목록이 재귀형 데이터 인지 
 * children     | 옵셔널 |  []   | 검색 컴포넌트
 * singleUpdateRequest | 옵셔널 | obj  | 업데이트를 위한 데이터를 담을 객체
 * */



function ITER_SimmsDrawer({onChange, data, showLabel, title, entity, parentKey, constraint, auth, recursive,  uniqueKey, children, type, ...rest }) {
    const prevDataRef = useRef();

    useEffect(() => {
        const fetchData = async () => {
            if (data?.rawValue==='USER') {
                try {
                    if (!isEqual(prevDataRef.current, data)) {
                        prevDataRef.current = data;

                        const response = await getUser(data.id);

                        const name = response.data.name;
                        setLabel(name);
                    }
                } catch (error) {
                    setLabel(rest.readOnly ? '': '선택'); // 오류 시 기본값 설정
                }
            } else {
                setLabel(data?.name ?? data?.assetName ??  (rest.readOnly ?'': '선택'));
            }
            if (autoClose) {
                closeDrawer();
            }
        };

        fetchData(); // 비동기 함수 호출
    }, [data]);

    const [autoClose, setAutoClose] = useState(true)
    const [label, setLabel] =useState();
    const [subSelected, setSubSelected] = useState({});
    const [slideIn, setSlideIn] =useState(false);
    const [expandedMenus, setExpandedMenus] = useState({});
    const {dataSet, loading,pageInfo, handlePageChange } = useCodeData(entity, uniqueKey);

    const closeDrawer=()=>{
        document.body.style.overflow = "auto";
        setSlideIn(false)
    }

    const user = useSelector((state) => state.auth.user);
    const adminAuth = isAdmin(user);
    const [state, setState] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [inputData, setInputData] = useState(null);
    const handleApiSelect = useHandleApiSelect();
    const {t} = useTranslation();

    const handleInputEnter = (e, top = false) => {
        if(e.key === "Enter"){
            // 최상위 등록 시 코드가 아닌 서비스코드일 시 1을 넣어줘야함

            handleApiSelect(entity,
                top ? (parentKey ? parentKey : 1) : selectedId,
                parentKey,
                top ? inputData?.top : inputData?.sub,
                () => {
                    setInputData(prev => {
                        return top
                            ? { ...prev, top: "" }
                            : { ...prev, sub: "" };
                    });

                    handleActiveToast({message: t(`saved`)});
                },
                () => {
                    handleActiveError({message: t(`duplicatedNameExisted`)})
                }
            );
        }
    }

    if(dataSet){
        const openDrawer =()=>{
            if(rest.readOnly){return }
            if(!auth) {
                alert("권한이 없습니다.")
                return;
            }
            document.body.style.overflow = "hidden";
            setSlideIn(true);
    }

    const handleCheckboxChange = (event) => {
        setAutoClose(event.target.checked);
    };


    let codes = [];
    if(!loading) {
        if (parentKey) {
            codes = dataSet.filter(each => each.id === parentKey);
        } else {
            codes = [{children : dataSet.content ?? dataSet}];
        }
    }

    const searchOnchangeHandler = (e) => {
        let filteredData= []
        let content = dataSet
        if(dataSet.content) content = dataSet.content
        filteredData = getFlatCode(content).filter(item => item.name.toLowerCase().includes(e.target.value.toLowerCase()))
        const idsFromParentToSelectedCode
            = e.target.value.trim() !== ''? getIdsFromMulipleMeToParent(filteredData, content) : []
        findByText(idsFromParentToSelectedCode)
    }

    function findByText (idsFromParentToSelectedCode){
        const updatedExpandedMenus = { ...expandedMenus };
        idsFromParentToSelectedCode
            .forEach(id => {
                updatedExpandedMenus[id] = true;
            });
        Object.keys(updatedExpandedMenus).forEach(id => {
            updatedExpandedMenus[id] = idsFromParentToSelectedCode
                .includes(Number(id));
        });
        setExpandedMenus(updatedExpandedMenus);
    }

    const childrenWithProps = React.Children.map(children, child => {
        if (React.isValidElement(child)) {
            return React.cloneElement(child, { setter: setSubSelected , selected:subSelected});
        }
        return child;
    });

    return (
        <div className={"block mr-2 my-[2px]"}>
            {showLabel && <Label> {title}</Label>}
            {/*선택버튼*/}
            <DrawerTriger onClick={openDrawer} required={constraint?.required} readOnly={rest.readOnly}  value={label}>{label}</DrawerTriger>
            <div className={`drawer-background ${slideIn ? 'show' : 'none'}`} onClick={() => closeDrawer()}></div>


            {/*드로어*/}
            <div className={`drawer-view px-[2rem] py-[1rem] ${slideIn ? 'slide-in' : ''}`}
                 style={{width: '450px'}}>

                {/*드로어 헤더*/}
                <div className="flex drawer-title border-bb">
                    <span className={`text-[20px] font-bold`}>{title}</span>
                    <img src={Close} className="close-drawer2" onClick={closeDrawer}/>
                </div>

                {childrenWithProps ?(
                <div className={`children-mb-3 'isDetailOpen grid  grid-cols-2`}>
                    {childrenWithProps}
                </div>
                    ):(
                <div className={'flex'}>
                    <input autoComplete="off" id="name" placeholder={`검색하세요.`}
                           onChange={searchOnchangeHandler}
                           className={"outline-1 flex w-[calc(100%-55px)] h-[30px] mb-[10px] border line-height-30 pl-[10px]"}/>
                    <p className={` text-center border h-[30px] w-[50px] py-[5px]  ml-[5px]`}>검색</p>
                </div>
                )}
                <div className={'flex'}>
                    <JellyCheckBox
                        title={"자동닫힘"}
                        checked={autoClose}
                        fnc={handleCheckboxChange}
                    />
                </div>

                {
                    !state ?
                        <div className="truncate flex h-[30px] mb-[10px] border line-height-30 pl-[10px]">
                            {label}
                        </div> :
                        <div className="truncate flex h-[30px] mb-[10px] border line-height-30 border-red-400 border-2">
                            <input className={"w-full text-indent text-[12px] focus:outline-none focus:border-none focus:shadow-none"} placeholder={"등록하실 최상위 코드를 입력하세요."} autoFocus
                                   onChange={(e) =>
                                       setInputData(prev => ({
                                           ...prev,
                                           top: e.target.value,
                                       }))
                                   }
                                   onKeyDown={(e) => handleInputEnter(e, true)}
                                   value={inputData?.top}
                            />
                        </div>
                }

                <div className={`border overflow-y-auto h-drawer`}
                     style={{
                         height: `calc(100vh - ${pageInfo.totalPages > 0 ? 280 : 250}px)`,
                     }}
                >
                    {!loading &&
                        <ITER_List list={codes[0].children}
                                   entity={entity}
                                   onChange={onChange}
                                   data={data}
                                   expandedMenus={expandedMenus}
                                   setExpandedMenus={setExpandedMenus}
                                   recursive={recursive}
                                   state={{state : state, setState : setState}}
                                   selectedId={{selectedId : selectedId, setSelectedId : setSelectedId}}
                                   inputData={{inputData : inputData, setInputData : setInputData}}
                                   handleInputEnter={handleInputEnter}
                        />}
                </div>
                {pageInfo && pageInfo.totalPages > 0 &&
                    <CommonPagination  page={pageInfo} onPageChange={handlePageChange}/>
                }

                {/*관리자권한이고, 재귀형 코드이고, 목록이 아닐때*/}
                {
                    adminAuth && recursive && !showLabel && (
                        !state ?
                            <Link className={`btn_save mt-2`} style={{ marginLeft : 0, textIndent : 0}} onClick={() => setState(!state)}>등록</Link> :
                            <div className={"mt-2 flex items-center justify-between"} style={{textIndent : 0}}>
                                <Link className={`btn_delete ml-0`} style={{ marginLeft : 0}} onClick={() => {setState(!state); setSelectedId(null);}}>취소</Link>
                                <span className={""}>※ 수정 및 삭제는 환경설정에서 가능합니다</span>
                            </div>
                    )
                }
            </div>

        </div>

    );}
}

export default ITER_SimmsDrawer;
